import { Box, ToggleButton, ToggleButtonGroup, Tooltip, Typography, useTheme } from "@mui/material";
import { EditLocation, Groups } from "@mui/icons-material";
import { useTranslation } from "react-i18next";
import { dashboardToggleButtonGroupSx } from "../../Dashboard/dashboard-toggle-button-group.styles";

export enum ScheduleMode {
  Colleague = "colleague",
  Resource = "resource"
}

type P = {
  scheduleMode: ScheduleMode;
  setScheduleMode: (mode: ScheduleMode) => void;
  /** Smaller icons — dashboard filter panel only. Selected state still uses primary. */
  compact?: boolean;
};

const COMPACT_ICON_SIZE = 20;
const DEFAULT_ICON_SIZE = 32;

export function ScheduleModeToggle({
  scheduleMode,
  setScheduleMode,
  compact = false
}: Readonly<P>) {
  const { t } = useTranslation();
  const theme = useTheme();
  const iconSize = compact ? COMPACT_ICON_SIZE : DEFAULT_ICON_SIZE;

  return (
    <ToggleButtonGroup
      value={scheduleMode}
      exclusive
      size="small"
      color="primary"
      onChange={(_, value: ScheduleMode | null) => value && setScheduleMode(value)}
      data-testid="schedule-mode-toggle"
      sx={dashboardToggleButtonGroupSx(theme, { compactTouchTargets: compact })}
    >
      <ToggleButton
        value={ScheduleMode.Colleague}
        aria-label={t("Colleagues")}
        data-testid="schedule-mode-colleague"
      >
        <Tooltip title={<Typography>{t("Colleagues")}</Typography>}>
          <Box component="span" sx={{ display: "inline-flex", alignItems: "center" }}>
            <Groups sx={{ fontSize: iconSize }} />
          </Box>
        </Tooltip>
      </ToggleButton>

      <ToggleButton
        value={ScheduleMode.Resource}
        aria-label={t("Resource")}
        data-testid="schedule-mode-resource"
      >
        <Tooltip title={<Typography>{t("Resource")}</Typography>}>
          <Box component="span" sx={{ display: "inline-flex", alignItems: "center" }}>
            <EditLocation sx={{ fontSize: iconSize }} />
          </Box>
        </Tooltip>
      </ToggleButton>
    </ToggleButtonGroup>
  );
}
